import React, { useState } from 'react';
import { Breadcrumb, Typography, Space } from 'antd';
import { HomeOutlined, UserOutlined } from '@ant-design/icons';
import CustomerList from '../components/Customers/CustomerList';

const { Title } = Typography;

const CustomersPage = () => {
    return (
        <div>
            <Breadcrumb
                style={{ marginBottom: '16px' }}
                items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        title: (
                            <Space>
                                <UserOutlined />
                                <span>Customers</span>
                            </Space>
                        ),
                    },
                ]}
            />

            <div style={{ marginBottom: '24px' }}>
                <Title level={2}>Customers</Title>
            </div>

            <CustomerList />
        </div>
    );
};

export default CustomersPage;
